module.exports = __webpack_public_path__ + "media/bifold-easel.1283ba67.mp4";